/**
 * Where a question is being answered, named by the Contentful ids of the
 * entities it hangs under
 */
export const placementAnswerKey = (placement, questionId) =>
  [
    placement?.collectionId ?? "",
    placement?.setId ?? "",
    placement?.activityId ?? "",
    questionId ?? "",
  ].join("/");

/**
 * The placement of the sections of one tree node: its ancestors, plus the node
 * itself as the activity - a set that carries content sections of its own is
 * its own activity level, which is how the server resolves it too.
 */
export const placementIdsOfNode = (node) => ({
  collectionId: node?.placement?.collectionId ?? null,
  setId: node?.placement?.setId ?? null,
  activityId: node?.id ?? null,
});

/**
 * The placement of the sections rendered for a chain of tree nodes. Only the
 * leaf is read: every node carries the ids of its own ancestors.
 */
export const placementIdsFromChain = (chain) => {
  const nodes = Array.isArray(chain) ? chain : [];

  return placementIdsOfNode(nodes[nodes.length - 1]);
};

/**
 * The key a stored answer or quiz attempt belongs under, read off the row the
 * server wrote: it holds the placement the server confirmed, which is what the
 * next fetch will be keyed by.
 */
export const placementAnswerKeyOfRow = (row) =>
  placementAnswerKey(
    {
      collectionId: row?.collection ?? null,
      setId: row?.set ?? null,
      activityId: row?.activity ?? null,
    },
    row?.question,
  );

export const placementAnswerKeyOfSection = (section) =>
  placementAnswerKey(
    placementIdsOfNode(section?.activity),
    section?.contentSection?.id,
  );

export const ANSWER_KEY_PARAM = "answerKey";

export const answerKeyQuery = (answerKey) =>
  answerKey ? `?${ANSWER_KEY_PARAM}=${encodeURIComponent(answerKey)}` : "";

export const findSectionForAnswerKey = (sections, questionId, answerKey) => {
  const list = Array.isArray(sections) ? sections : [];

  if (answerKey) {
    const placed = list.find(
      (section) => placementAnswerKeyOfSection(section) === answerKey,
    );

    if (placed) return placed;
  }

  return list.find((section) => section?.contentSection?.id === questionId);
};
